var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-love_1_",
    "data-name": "search-love (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.252,
    height: 22.27,
    viewBox: "0 0 22.252 22.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M4.491,26.313l-1.63,1.629a.983.983,0,0,1-.435.266,3.281,3.281,0,0,0,.641,6.426h.206a3.259,3.259,0,0,0,3.14-2.385.978.978,0,0,1,.272-.44l1.657-1.63a9.723,9.723,0,0,1-3.851-3.867ZM4.42,32.527a1.63,1.63,0,1,1-2.3-2.3,1.63,1.63,0,1,1,2.3,2.3Zm9.044-13.139a.543.543,0,0,1-.8,0,1.7,1.7,0,0,0-1.244-.641,1.352,1.352,0,0,0-.348.043,1.677,1.677,0,0,0-.581,2.955l2.6,2.5,2.781-2.482a1.912,1.912,0,0,0-.228-2.64A1.438,1.438,0,0,0,13.464,19.387Z",
    transform: "translate(-0.033 -12.364)",
    fill: "#ffbdbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4644",
    "data-name": "Path 4644",
    d: "M18.061,11a7.061,7.061,0,1,0,7.061,7.061A7.061,7.061,0,0,0,18.061,11Zm3.617,7.957a.511.511,0,0,1-.054.054l-3.183,2.852a.543.543,0,0,1-.739,0l-2.96-2.852a2.759,2.759,0,0,1,1.059-4.8,2.6,2.6,0,0,1,2.276.543,2.444,2.444,0,0,1,3.259.033A2.987,2.987,0,0,1,21.679,18.957Z",
    transform: "translate(-5.043 -8.827)",
    fill: "#ffbdbf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    d: "M15.318,7a9.234,9.234,0,1,0,9.234,9.234A9.234,9.234,0,0,0,15.318,7Zm0,17.381a8.148,8.148,0,1,1,8.147-8.147A8.147,8.147,0,0,1,15.318,24.381ZM5.155,25.625a.544.544,0,1,0,.766,0,.543.543,0,0,0-.766,0Z",
    transform: "translate(-2.299 -7)",
    fill: "#ffbdbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLove);
export default __webpack_public_path__ + "static/media/search-love.ac1bb214d14c6e9a466b56c92f077edb.svg";
export { ForwardRef as ReactComponent };